"use client"

import { useMixpanel } from "@src/providers/MixpanelProvider"
import { GA4_MEASUREMENT_ID } from "@src/utils/analyticsIds"
import { useEffect } from "react"
import { useAnalyticsSuppressed } from "./useAnalyticsSuppressed"
export function useAnalyticsOptOut() {
  const mixpanel = useMixpanel()
  const suppressed = useAnalyticsSuppressed()

  useEffect(() => {
    const w = window as unknown as Record<string, boolean>
    w[`ga-disable-${GA4_MEASUREMENT_ID}`] = suppressed

    if (!mixpanel) return
    try {
      if (suppressed) {
        mixpanel.opt_out_tracking()
      } else {
        mixpanel.opt_in_tracking()
      }
    } catch {
      // Analytics opt-in/out must never propagate exceptions.
    }
  }, [suppressed, mixpanel])
}
